import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService extends FgiBackEndService<any> {

  // @Override (obrigado a sobrescrever. Nao faz sentido para o nosso caso.)
  getNewEntity() {
    return null;
  }

  protected getResourceURL(): string {
    return 'front/usuarios';
  }

  getNomeUsuario(userId: string): Observable<string> {
    return this.http.get(`${this.BASE_URL}/userId/${userId}`,
    {responseType: 'text'}) as Observable<string>;
  }
}